<script setup>
import {useForm} from "@inertiajs/inertia-vue3";

const form = useForm({
    email: null,
    password: null,
})

const login = () => {
    form.post(route('login'))
}

</script>

<template>

    <form @submit.prevent="login" action="#" method="POST">
        <div class="rounded-md shadow-sm -space-y-px">
            <div class="mb-3 text-white text-sm">
                Log In
            </div>
            <div>
                <label for="email-address" class="sr-only">E-mail</label>
                <input v-model="form.email"
                       :class="{'border-red-500': form.errors.email}"
                       id="email-address"
                       name="email"
                       type="email"
                       autocomplete="email"
                       required=""
                       class="appearance-none rounded-none relative block w-full mb-3 px-3 py-2 bg-neutral-700 placeholder-neutral-500 text-neutral-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                       placeholder="E-mail" />
            </div>
            <div>
                <label for="password" class="sr-only">Password</label>
                <input v-model="form.password"
                       :class="{'border-red-500': form.errors.email}"
                       id="password"
                       name="password"
                       type="password"
                       autocomplete="current-password"
                       required=""
                       class="appearance-none rounded-none relative block w-full mb-3 px-3 py-2 bg-neutral-700 placeholder-neutral-500 text-neutral-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                       placeholder="Password" />
            </div>
        </div>

        <div class="text-red-500" v-if="form.errors.email">{{ form.errors.email }}</div>

        <div>
            <button type="submit"
                    class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-dark  hover:bg-red-900 focus:outline-none"
                    :disabled="form.processing"
            >
                Log In
            </button>
        </div>
    </form>

</template>
